/** Jurisdiction types for business entity */
export enum JurisdictionTypeEnum {
  /** Jurisdiction of the Russian Federation  */
  RUSSIAN_FEDERATION = 'RUSSIAN_FEDERATION',
  /** Foreign Jurisdiction */
  FOREIGN = 'FOREIGN'
}
